module.exports = __webpack_public_path__ + "img/construction.cea47db5.png";